// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.phoneverification.RentalManagerUserPhoneVerificationV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode,
  RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  PhoneVerificationSendVerificationCodeRequestDto,
  PhoneVerificationSendVerificationCodeV2Dto,
  PhoneVerificationValidateVerificationCodeRequestDto,
  PhoneVerificationValidateVerificationCodeV2Dto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Args {
  postData: PhoneVerificationSendVerificationCodeRequestDto;
}

export type RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Options = UseMutationOptions<
  PhoneVerificationSendVerificationCodeV2Dto,
  unknown,
  RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Args
>;

/**
 * Send a verification code to the provided phone
 */
export const useRentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode_Args) =>
      RentalManagerUserPhoneVerificationV2WebApiHandler_sendVerificationCode(args.postData, httpClient),
  });
};

export interface RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Args {
  postData: PhoneVerificationValidateVerificationCodeRequestDto;
}

export type RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Options = UseMutationOptions<
  PhoneVerificationValidateVerificationCodeV2Dto,
  unknown,
  RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Args
>;

/**
 * Determine if the verification code is valid for the phone being verified
 */
export const useRentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode_Args) =>
      RentalManagerUserPhoneVerificationV2WebApiHandler_validateVerificationCode(args.postData, httpClient),
  });
};
